import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungHildesheim() {
  return (
    <CityPageTemplate
      city="Hildesheim"
      slug="hildesheim"
      intro="Hildesheim als UNESCO-Welterbe-Stadt – Deine Finanzen verdienen genauso viel Pflege und Aufmerksamkeit."
      description="Unabhängige & digitale Finanzberatung für Hildesheim: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
